<template>
  <v-container fluid class="v-window-item">
    <v-overlay
      v-if="loading"
      absolute
      color="white"
      opacity="0.7"
    >
      <v-progress-circular
        indeterminate
        :color="color"
      />
    </v-overlay>
    <slot />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'VDialogContainer',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
</script>

<style lang="scss" scoped>
.v-window-item {
  max-height: calc(90vh - 48px - 52px - 12px);
  overflow-y: auto;
  position: relative;
}
</style>
